// extracted by mini-css-extract-plugin
export default {"blockContent":"ListDetailsSider_blockContent__joPun","gdprMessage":"ListDetailsSider_gdprMessage__nLpVm"};